function upsellHooks() {

    window.FastRecommendationWidget.registerHook("serp-product-swatches", ({colors, swatchClick, showMoreClick, element}) => {
        let curProductElement = element.closest('.fs-upsell-cross-sell-product');

        console.log('serp-product-swatches');

        element.querySelectorAll(".color-swatch-container").forEach((container) => {
            const swatchColor = container.querySelector(".color-swatch");
            const colorNameEl = container.querySelector(".fs-color-name");        

            if (!swatchColor || !colorNameEl) return;

            const colorName = colorNameEl.textContent.trim();

            const colorClassName = colorName
            .toLowerCase()
            .replace(/\s+/g, "");

            if (!colorClassName) return;        

            swatchColor.classList.add(colorClassName);        
            swatchColor.classList.add('swatch-color');

            // Add tooltip text to container
            container.setAttribute("data-color-name", colorName);        
        });
    });


    window.FastRecommendationWidget.registerHook('upsell-quick-view', ({ product, index, onClose, element }) => {

        console.log('upsell-quick-view');

        const productID = product.id;
        const data = product;
        const productElement = element;

        const swatches = productElement.querySelectorAll('.fast-swatch-color-fallback');

        swatches.forEach((swatch) => {
            const container = swatch.closest('.color-swatch-container');

            // Find the color name next to this swatch
            const colorName = swatch
            .closest('.color-swatch-container')
            ?.querySelector('.color-swatch-color-name')
            ?.textContent
            ?.trim()
            .toLowerCase()
            .replace(/\s+/g, ''); // "Bright White" -> "brightwhite"

            swatch.classList.add('swatch-color');

            if (colorName) {
                swatch.classList.add(colorName);            
                container?.setAttribute('data-color-name', colorName);
            }
        });

        const priceContainer = productElement.querySelector(".quick-view-price-wrapper");
        if (priceContainer) {           
            if (!productElement.querySelector(".fs-flair-badges-wrapper")) {
            priceContainer.insertAdjacentHTML(
                "beforebegin",
                `
                <div class="fs-flair-badges-wrapper">
                <flair-badges product-id="${productID}" tags="collection" layout="collection title" auto-layout="collectiontest"></flair-badges>
                </div>
                `
            );
            }

            if (!productElement.querySelector(".fs-flair-banners-wrapper")) {
            priceContainer.insertAdjacentHTML(
                "afterend",
                `
                <div class="fs-flair-banners-wrapper">
                <flair-banners product-id="${productID}" tags="collection" layout="collection title" auto-layout="collectiontest"></flair-banners>
                </div>
                `
            );
            }
        }

    });

    window.FastRecommendationWidget.registerHook("upsell-cross-sell-products", ({element, products}) => {
        const productElements = [...element.querySelectorAll(".fs-upsell-cross-sell-product")];

        for (const productElement of productElements){
            const productID = productElement.dataset.id;
            const data = products[productID];

            if (typeof data === "undefined" || data === null) continue;

            const infoContainer = productElement.querySelector(".fs-recommendation-product-info");
            if (!infoContainer) continue;      

            /**
            * Flair badges/banner
            */
            if (!productElement.classList.contains("fs-flair-added")) {
                if (!productElement.querySelector(".fs-flair-badges-wrapper")) {
                    infoContainer.insertAdjacentHTML(
                    "beforebegin",
                    `
                    <div class="fs-flair-badges-wrapper">
                        <flair-badges product-id="${productID}" tags="collection" layout="collection title" auto-layout="collectiontest"></flair-badges>
                    </div>
                    `
                    );
                }

                if (!productElement.querySelector(".fs-flair-banners-wrapper")) {
                    infoContainer.insertAdjacentHTML(
                    "afterend",
                    `
                    <div class="fs-flair-banners-wrapper">
                        <flair-banners product-id="${productID}" tags="collection" layout="collection title" auto-layout="collectiontest"></flair-banners>
                    </div>
                    `
                    );
                }

                productElement.classList.add("fs-flair-added");
            }


            /**
            * Compare price
            */
            const compareElement = productElement.querySelector(".fs-recommendation-product-compare-price .compare-price");
            const priceContainer = productElement.querySelector(".fs-recommendation-price-container .fs-recommendation-product-price");

            if (compareElement && priceContainer && !productElement.querySelector(".upsell-compare-price")) {
            const compareValue = compareElement.textContent.trim();

            const comparePriceDiv = document.createElement("div");
            comparePriceDiv.classList.add("upsell-compare-price");
            comparePriceDiv.textContent = compareValue;

            priceContainer.appendChild(comparePriceDiv);
            }


            // Discount percentage badge
            const comparePrice = parseFloat(data.p_c);
            const salePrice = parseFloat(data.p);

            if (
            !isNaN(comparePrice) &&
            !isNaN(salePrice) &&
            comparePrice > salePrice &&
            !productElement.querySelector(".discount_percent") &&
            productElement.classList.contains("fs-product-has-compare-price")
            ) {
            const priceContainer = productElement.querySelector(".price-is-compare");
            if (priceContainer) {
                const discountPercent = Math.ceil(((comparePrice - salePrice) / comparePrice) * 100);
                const discountEl = document.createElement("div");
                discountEl.classList.add("discount_percent");
                discountEl.textContent = `${discountPercent}% Off`;
                priceContainer.appendChild(discountEl);
            }
            }
            
        }
    });
}

if (window.FastRecommendationWidget) {
    upsellHooks();
} else {
    window.addEventListener('fast-upsell-cross-sell-ready', function () {
        upsellHooks();
    });
}



